import { fade, Grid, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
const useTCardPreviewStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(7, 6),
        maxWidth: 350,
        minWidth: 300,
        width: '100%',
        background: fade('#17278D', 0.8),
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: theme.spacing(2),
        backgroundRepeat: 'no-repeat',
        height: 190,
        color: 'white',
    },
    colorized: {
        boxShadow: '0px 4px 8px rgba(121, 75, 255, 0.32)',
        background: 'linear-gradient(215.92deg, #FA5D75 7.33%, rgba(210, 95, 157, 0.9) 39.56%, rgba(120, 100, 246, 0.67) 78.46%)',
    },
    title: {
        fontSize: 16,
    },
    descriptionTitle: { fontSize: 14 },
    descriptionBody: { fontSize: 16 },
    balance: { fontSize: 14 },
}));
const TCardPreview = ({ name, text, icon, description, subDescription, }) => {
    const classes = useTCardPreviewStyles();
    return (React.createElement(Grid, { className: clsx(classes.root, {
            [classes.colorized]: name === 'WALLET',
        }), container: true, direction: 'column', justifyContent: 'space-between' },
        React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between' },
            React.createElement(Typography, { className: classes.title, variant: 'subtitle1', color: 'inherit' }, text),
            React.createElement(Typography, { variant: 'subtitle1', color: 'inherit' }, icon)),
        React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between', alignItems: 'flex-end' },
            React.createElement(Grid, { item: true, xs: true },
                (description === null || description === void 0 ? void 0 : description.text) && (React.createElement(Typography, { className: classes.descriptionTitle, variant: 'body2', color: 'inherit' }, description === null || description === void 0 ? void 0 : description.text)),
                (description === null || description === void 0 ? void 0 : description.body) && (React.createElement(Typography, { className: classes.descriptionBody, variant: 'subtitle1', color: 'inherit' }, description === null || description === void 0 ? void 0 : description.body))),
            React.createElement(Typography, { className: classes.balance, variant: 'subtitle2', color: 'inherit' }, subDescription))));
};
export default TCardPreview;
